import React,{ Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from "../../../../components/SelectWrap";
import { handleFieldChange } from "../../../../Utils";

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dateFrom: '',
            dateTo: '',
            affid: null
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(e) {
        e.preventDefault();

        this.props.onSubmit(this.state);
    }

    render() {
        return (
            <form onSubmit={this.handleFormSubmit}>
                <Row>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="dateFrom"
                            label="Date From:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateFrom}
                        />
                    </Col>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="dateTo"
                            label="Date To:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateTo}
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.affidValues}
                            label="Affid:"
                            name="affid"
                            onChange={this.handleFieldChange}
                            value={this.state.affid}
                            multi
                        />
                    </Col>
                </Row>

                <Button type="submit" bsStyle="info" className="m-b-15" >Apply</Button>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/AdkBlock/components/Form/index.js